import { Component, Input, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Country } from '../../../../model/country.model';
import { Region } from '../../../../model/region.model';
import { District } from '../../../../model/district.model';
import { SearchBarService } from '../../../../services/utils/searchBar.service';

@Component({
  selector: 'app-mobile-searchbar',
  templateUrl: './mobile-searchbar.component.html',
  styleUrls: ['./mobile-searchbar.component.scss'],
  standalone: false
})
export class MobileSearchbarComponent implements AfterViewInit {

  @Output() sort = new EventEmitter<void>();
  @Output() filter = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();
  @Input() country?: Country;
  @Input() region?: Region;
  @Input() district?: District;
  isStuck = false;
  @ViewChild('filteringRef', { static: true }) filteringRef!: ElementRef;
  filteringHeight = 0;
  private offsetTop = 112;
  private isInitialized = false;

  constructor(protected searchService: SearchBarService) { }


  ngAfterViewInit() {
    setTimeout(() => {
      this.calculateOffsetTop();
      this.isInitialized = true;
      this.checkSticky();
    }, 0);
  }

  private calculateOffsetTop() {
    try {
      if (!this.filteringRef?.nativeElement) return;

      this.filteringHeight = this.filteringRef.nativeElement.offsetHeight || 56;
      const rect = this.filteringRef.nativeElement.getBoundingClientRect();
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || window.scrollY;
      this.offsetTop = rect.top + scrollY;
    } catch (e) {
      console.error('Error measuring filtering element', e);
    }
  }

  private checkSticky() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || window.scrollY;
    const shouldBeStuck = scrollY >= this.offsetTop;
    if (shouldBeStuck !== this.isStuck) {
      this.isStuck = shouldBeStuck;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.isInitialized) return;
    this.checkSticky();
  }

  @HostListener('window:resize', [])
  onWindowResize() {
    this.calculateOffsetTop();
    this.checkSticky();
  }


  onSort() {
    this.sort.emit();
  }

  onFilter() {
    this.filter.emit();
  }

  onEdit() {
    this.edit.emit();
  }

  get currentSorting() {
    return this.searchService.selectedSort + '-' + this.searchService.selectedDirection;
  }
}